import * as React from 'react';
/**
 * Krok MRGD7 (dotazeno v TECH1) — ODLOZENA AKCE, KTERA SE PRI ODMONTOVANI ZRUSI.
 *
 * Obrazovky odkladaji dve veci: posun na sekci, ktera v DOM jeste neni (0 ms,
 * az po prekresleni), a znovunacteni dat po dobehnutem behu na serveru (sekundy).
 * Psalo se to jako `window.setTimeout(…)` bez uklidu — timer pak bezel i po
 * odchodu z obrazovky, menil stav odmontovane komponenty (React to hlasi jako
 * „state update on an unmounted component") a poslal dotaz, ktery uz nikdo necte.
 *
 * `later(fn, ms)` si id timeru pamatuje a uklidovy efekt je pri odmontovani
 * vsechny zrusi. Funkce je stabilni (`useCallback` bez zavislosti), takze se da
 * predat do `useEffect` i do handleru bez prekresleni.
 */
export function useLater() {
    const timers = React.useRef([]);
    React.useEffect(() => () => {
        for (const id of timers.current)
            window.clearTimeout(id);
        timers.current = [];
    }, []);
    return React.useCallback((fn, ms) => {
        const id = window.setTimeout(() => {
            timers.current = timers.current.filter((running) => running !== id);
            fn();
        }, ms);
        timers.current = [...timers.current, id];
    }, []);
}
//# sourceMappingURL=use-later.js.map